module.exports = __webpack_public_path__ + "img/16437a2.png";